import { supabase } from '@/lib/supabase';

export async function getAccessToken() {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  return session?.access_token ?? null;
}

export async function requireAccessToken() {
  const token = await getAccessToken();

  if (!token) {
    throw new Error('Authentication required');
  }

  return token;
}

export async function getAuthHeaders(headers?: HeadersInit) {
  const token = await requireAccessToken();

  return {
    ...(headers ?? {}),
    Authorization: `Bearer ${token}`,
  };
}

export async function getOptionalAuthHeaders(headers?: HeadersInit) {
  const token = await getAccessToken();

  return {
    ...(headers ?? {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function fetchWithAuth(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = await getAuthHeaders(init.headers);
  return fetch(input, {
    ...init,
    headers,
  });
}

export async function fetchWithOptionalAuth(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = await getOptionalAuthHeaders(init.headers);
  return fetch(input, {
    ...init,
    headers,
  });
}
